import React from 'react';
import Droppable from '../DnD/Droppable';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VImage from '../VImage/VImage';
// import { designActions } from '../../actions';
// import { ReactSVG } from 'react-svg';
import './VFrame.css';
import { generateImageLink, getImageExtention } from '../../utils/design.utils';

class Frame extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      svg: null,
      loading: false,
    };

    const extension = getImageExtention(this.props.url);
    let svgUrl =
      extension && extension !== 'svg'
        ? this.props.url.replace(new RegExp(`\\.${extension}(?=([?#]|$))`, 'i'), '.svg')
        : this.props.url;
    svgUrl = generateImageLink(svgUrl, this.props.authToken);
    fetch(svgUrl, {
      credentials: 'include',
      method: 'GET',
    })
      .then(res => res.text())
      .then(text => this.setState({ svg: text }));
  }

  // componentDidMount() {
  // }

  getMeta(url) {
    var w;
    var h;
    var img = new Image();
    img.src = url;
    img.onload = function () {
      w = this.width;
      h = this.height;
    };
    return { w: w, h: h };
  }

  updateId(parent, elID) {
    let i, cur;
    var numCompare = elID;
    var children = parent.children;
    for (i = 0; i < children.length; i++) {
      cur = children[i];

      if (cur.nodeType === 1 && cur.id) {
        // cur.id = cur.id + "_" + numCompare;
        if (cur.id === 'mask') {
          this.maskID = 'CP_' + numCompare + '_' + (i + 1);

          cur.id = this.maskID;
        } else {
          cur.id = 'CP_' + numCompare + '_' + (i + 1);
        }
      }
      this.updateId(cur, numCompare);
    }
  }

  render() {
    const { loading, svg } = this.state;
    if (loading) {
      return <div className="spinner" />;
    } else if (!svg) {
      return <div className="error" />;
    }
    let clipPath = this.state.svg.replace('<mask', `<clipPath style='transform: scale(${this.props.scale})' `);
    clipPath = clipPath.replace('</mask', '</clipPath');
    const div = document.createElement('div');
    div.innerHTML = clipPath;

    const preview = div.querySelector('#preview');

    if (preview) preview.remove(preview);

    this.updateId(div, this.props.id);

    const minWidth = _.get(this.props.frameSize, 'width');
    const minHeight = _.get(this.props.frameSize, 'height');
    const imageMinSize = { width: minWidth, height: minHeight };

    let maskHolderStyle = {
      clipPath: `url("#${this.maskID}")`,
      backgroundColor: this.props.bgColor,
      ..._.get(this.props, 'flip', { transform: 'scale(1)' }),
    };
    // if (this.props.bgColor) {
    //   maskHolderStyle = {
    //     clipPath: `url("#${this.maskID}")`,
    //     backgroundColor: this.props.bgColor,
    //     ..._.get(this.props, 'flip', { transform: 'scale(1)' }),
    //   };
    // } else {
    //   maskHolderStyle = {
    //     clipPath: `url("#${this.maskID}")`,
    //     backgroundColor: this.props.bgColor,
    //   };
    // }

    return (
      <div
        className={`frameMaskHolder ${this.props.bgColor ? 'solidColor' : ''} flipper`}
        style={maskHolderStyle}
      // style={{ clipPath: `url("#${this.maskID}")`, backgroundColor: this.props.bgColor }}
      >
        {/* <img src={this.props.src ? this.props.src : this.props.imgUrl} /> */}
        {this.props.imgUrl && (!this.props.bgColor || this.props.src) && (
          <VImage
            entityId={this.props.id}
            internal
            src={this.props.src ? this.props.src : this.props.imgUrl}
            type={this.props.mediaType}
            dataTarget={`F_${this.props.id}`}
            parentSize={imageMinSize}
          />
        )}

        <div style={{ width: '100%', height: '100%' }} dangerouslySetInnerHTML={{ __html: div.innerHTML }} />
      </div>
    );
  }
}

const VFrame = props => {
  const entity = useSelector(state => state.design.entitiesState[props.entityId]);
  const authToken = useSelector(state => state.authentication.user.authToken);
  let cropStyle = _.get(entity.data, 'medias.inner');
  let maskSrc = entity.data.src;
  let imageSrc = _.get(
    entity,
    'data.medias.frame.src',
    `${process.env.REACT_APP_FILE_SERVER}/resources/frames/framePic/screen.jpg`,
  );
  let mediaType = _.get(entity, 'data.medias.frame.type', 'Image');
  const entityBgColor = _.get(entity, 'data.medias.style.master.backgroundColor', 'transparent');
  let bgColor = entityBgColor && entityBgColor !== 'transparent' ? entityBgColor : '';
  // entity.data.medias.frame.src || `${process.env.REACT_APP_FILE_SERVER}/resources/frames/framePic/screen.jpg`;

  const frameScale = parseInt(entity.style.inner.width) / entity.data.width;

  return (
    <div
      id={`_${props.entityId}_`}
      data-lock={entity.lock}
      className={props.className}
      data-target={props.dataTarget}
      data-page={props.pageId}
      style={entity.style.master}
      onMouseDown={props.onMouseDown}
      onMouseOver={props.onMouseOver}
    >
      <div className="frameHolder fullWH" style={entity.style.inner}>
        <Droppable
          internal
          pageId={props.pageId}
          entityId={props.entityId}
          acceptList={['Image', 'Video']}
          area="frame"
        >
          <Frame
            id={props.entityId}
            src=""
            authToken={authToken}
            url={maskSrc}
            imgUrl={imageSrc}
            mediaType={mediaType}
            scale={frameScale}
            cropStyle={cropStyle}
            imgFlip={_.get(entity, 'data.medias.style.flip')}
            flip={_.get(entity, 'style.flip', { transform: 'scale(1)' })}
            bgColor={bgColor}
            frameSize={entity.style.inner}
          />
        </Droppable>
      </div>
    </div>
  );
};

VFrame.propTypes = {
  entityId: PropTypes.number,
  pageId: PropTypes.number,
};

export default VFrame;
